export default "__VITE_ASSET__C9u9rIVp__"